import React from 'react';
import {Box, Grid, Typography } from "@mui/material";
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend, ResponsiveContainer} from 'recharts';
import { generateClientMetrics } from '../../utilityFunctions/DataloveUtil'
import Swal from 'sweetalert';
import CustomLoader from "../../components/CustomLoader";


export default function MessagesInteraction(props) {

    const {loginUser} = props;

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    
    React.useEffect(() => {
        const fetchClientMetrics = async () => {
            setLoading(true);
            const clientMetrics = await generateClientMetrics(loginUser.jwtToken);
            setLoading(false);

            if(!clientMetrics){
                Swal({
                    title: "Error",
                    text: "Failed to fetch client metrics",
                    icon: "error",
                    button: "Ok",
                });
                return;
            }

            // Sort the data chronologically by month
            const sortedData = (clientMetrics.formattedStats || []).sort((a, b) => {
                return a.month.localeCompare(b.month);
            });

            console.log(sortedData);

            // Calculate ratios for each category
            const dataWithRatios = sortedData.map(item => {
                const total = item.totalMessages || 1; // Avoid division by zero
                return {
                    month: item.month,
                    totalRatio: 1, // Always 100%
                    receivedRatio: item.receivedMessages / total,
                    respondedRatio: item.respondedMessages / total,
                    sentRatio: item.sentMessages / total,
                    deliveredRatio: item.deliveredMessages / total,
                    // Keep original values for reference
                    totalMessages: item.totalMessages,
                    receivedMessages: item.receivedMessages,
                    respondedMessages: item.respondedMessages,
                    sentMessages: item.sentMessages,
                    deliveredMessages: item.deliveredMessages
                };
            });

            setData(dataWithRatios);
            console.log("Chart data with ratios:", dataWithRatios);
        }
        fetchClientMetrics();
    }, []);

    // Helper function to format camelCase labels
    const formatLabel = (label) => {
        // Convert camelCase to Title Case With Spaces
        const formatted = label
            .replace(/Ratio/g, '') // Remove "Ratio" suffix
            .replace(/([A-Z])/g, ' $1') // Add space before capital letters
            .replace(/^./, (str) => str.toUpperCase()); // Capitalize first letter
        
        return formatted;
    };

    // Helper function to format percentage values
    const formatPercentage = (value) => {
        return `${(value * 100).toFixed(1)}%`;
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%", height: "100%" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: {xs: "start", sm: "start", md: "center"}, width: "95%", height: "90%", textAlign: "center", marginTop: { xs: "4.5rem", sm: "2rem", md: "0" } }}>
                {loading ? (
                    <CustomLoader />
                    ) : (
                        <Grid container direction="row" spacing={1} sx={{display: "flex", justifyContent: "center"}}>
                            <Grid item xs={12}>
                                <Typography variant="h4" sx={{ marginTop: "2rem", fontWeight: "bold" }}>SMS Interactions</Typography>
                            </Grid>
                            {data && data.length > 0 ? (
                                <Grid item xs={12} sx={{width: "100%", height: 400}}>
                                    <ResponsiveContainer width="100%" height={400}>
                                        <BarChart data={data}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis 
                                                dataKey="month" 
                                                angle={-90} 
                                                textAnchor="end" 
                                                height={70}
                                                tick={{fontSize: 10}}
                                            />
                                            <YAxis 
                                                tickFormatter={(value) => formatPercentage(value)}
                                            />
                                            <Tooltip 
                                                formatter={(value, name) => {
                                                    // Format the value as percentage and the name
                                                    return [formatPercentage(value), formatLabel(name)];
                                                }}
                                                labelFormatter={(label) => `Month: ${label}`}
                                            />
                                            <Legend 
                                                formatter={(value) => formatLabel(value)}
                                            />
                                            <Bar name="receivedRatio" dataKey="receivedRatio" fill="#01929b" stackId="a" />
                                            <Bar name="respondedRatio" dataKey="respondedRatio" fill="#f2736a" stackId="a" />
                                            <Bar name="sentRatio" dataKey="sentRatio" fill="#4a3596" stackId="a" />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </Grid>
                            ) : (
                                <Grid item xs={12}>
                                    <Typography variant="body1">
                                        No data available. Received: {JSON.stringify(data).substring(0, 100)}
                                    </Typography>                                
                                </Grid>
                            )}
                        </Grid>
                    )
                }           
            </Box>
        </Box>
    )
}
